/* eslint-disable no-loss-of-precision */
import blank from '../../Blank/blankData'

import Forehead2Lines from '../../FacialLines/ForeheadEyebrow'
import ForeheadEyebrow from '../../FacialLines/Forehead2Lines'
import ForeheadLine from '../../FacialLines/ForeheadLine'

const data = [
  blank,

  {
    id: 'Forehead2Lines',
    svg: Forehead2Lines,
    positioning: {
      pointNarrow: {
        y: 93.47172546386719,
        scaleX: 1,
      },
      pointMedium: {
        y: 91.83786010742188,
        scaleX: 1,
      },
      pointWide: {
        y: 89.20305633544922,
        scaleX: 1,
      },
      roundNarrow: {
        y: 96.1844482421875,
        scaleX: 1,
      },
      roundMedium: {
        y: 97.0023193359375,
        scaleX: 1,
      },
      roundWide: {
        y: 93.80540466308594,
        scaleX: 1,
      },
      squareNarrow: {
        y: 92.81729125976562,
        scaleX: 1,
      },
      squareMedium: {
        y: 91.28195190429688,
        scaleX: 1,
      },
      squareWide: {
        y: 93.03376770019531,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'ForeheadEyebrow',
    svg: ForeheadEyebrow,
    positioning: {
      pointNarrow: {
        y: 80.02442932128906,
        scaleX: 1,
      },
      pointMedium: {
        y: 80.97895812988281,
        scaleX: 1,
      },
      pointWide: {
        y: 79.83798217773438,
        scaleX: 1,
      },
      roundNarrow: {
        y: 82.35867309570312,
        scaleX: 1,
      },
      roundMedium: {
        y: 79.75199890136719,
        scaleX: 1,
      },
      roundWide: {
        y: 78.58967590332031,
        scaleX: 1,
      },
      squareNarrow: {
        y: 79.43025207519531,
        scaleX: 1,
      },
      squareMedium: {
        y: 79.96272277832031,
        scaleX: 1,
      },
      squareWide: {
        y: 80.1636962890625,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'ForeheadLine',
    svg: ForeheadLine,
    positioning: {
      pointNarrow: {
        y: 91.52145385742188,
        scaleX: 1,
      },
      pointMedium: {
        y: 89.69065856933594,
        scaleX: 1,
      },
      pointWide: {
        y: 86.09951782226562,
        scaleX: 1,
      },
      roundNarrow: {
        y: 94.36858367919922,
        scaleX: 1,
      },
      roundMedium: {
        y: 94.616943359375,
        scaleX: 1,
      },
      roundWide: {
        y: 91.64994049072266,
        scaleX: 1,
      },
      squareNarrow: {
        y: 91.60105895996094,
        scaleX: 1,
      },
      squareMedium: {
        y: 90.42869567871094,
        scaleX: 1,
      },
      squareWide: {
        y: 90.2795181274414,
        scaleX: 1,
      },
    },
  },
]

export default data
